<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="$route.meta.title"
          :link="[
            {
              text: $route.meta.title,
            },
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn class="ml-6" depressed dark color="#0D47A1" @click="openCreateDialog">
          <v-icon left>add</v-icon>Thêm quyền giao việc
        </v-btn>
      </div>
    </div>
    <v-card outlined class="pt-6 px-6 mx-4 mb-6 elevation-0">
      <ConfigRoleFilter :filter="filter" @onFilterChanged="onFilterChange" />
    </v-card>

    <v-dialog v-model="createState" width="620" height="90vh" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          <v-toolbar-title>THÊM QUYỀN GIAO VIỆC MỚI</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon @click="closeDialog">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <SetConfigRoleInput @onClose="closeDialog" @onFilterChanged="refresh" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card outlined class="mx-4 elevation-0">
      <ConfigRoleDataTable
        v-if="configs"
        :configsProp="configs"
        :isLoading="isLoading"
        @pagination="onPaginationChange"
      />
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ConfigRoleDataTable from '@/modules/task-new/ConfigRoleDataTable.vue'
import ConfigRoleFilter from '@/modules/task-new/ConfigRoleFilter.vue'
import SetConfigRoleInput from '@/modules/task-new/SetConfigRoleInput.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Breadcrumbs,
    SetConfigRoleInput,
    ConfigRoleDataTable,
    ConfigRoleFilter,
  },
  data() {
    return {
      isLoading: false,
      createState: false,
      filter: {
        creator: '',
        receiver: '',
      },
      pagination: {
        page: 0,
        limit: 50,
      },
    }
  },

  computed: {
    ...mapGetters('auth', ['profile', 'role']),
    ...mapGetters('configtaskroles', ['configs']),
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    openCreateDialog() {
      this.createState = true
    },
    closeDialog() {
      this.createState = false
    },
    async refresh() {
      this.isLoading = true
      await this.$store.dispatch('configtaskroles/fetchConfigTaskRoles', {
        creator: this.filter.creator,
        receiver: this.filter.receiver,
        _start: this.pagination.page,
        _limit: this.pagination.limit,
      })
      this.isLoading = false
    },
    onFilterChange(newFilter) {
      this.filter = { ...newFilter }
      this.pagination.page = 1
      this.refresh()
    },
    onPaginationChange(paging) {
      this.pagination.page = paging.page
      this.pagination.limit = paging.limit
      this.refresh()
    },
  },
}
</script>
